import React from 'react';
import { Form, Image, Col } from 'react-bootstrap';

const DirectorProfileImageUpload  = ({ profileImagePreview, handleImageChange }) => (
    <Col md={3} className="text-center mb-4">
        <div className="p-2 border border-secondary rounded bg-dark">
            {profileImagePreview ? <Image src={profileImagePreview} thumbnail fluid style={{maxHeight:'150px'}} className="mb-2 bg-dark border-0"/> : <div className="text-white small py-4">No Logo</div>}
            <Form.Control type="file" size="sm" onChange={handleImageChange} className="custom-form-input" style={{fontSize:'12px'}} />
        </div>
    </Col>
);

export default DirectorProfileImageUpload;